// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d2-drawer-container[data-v-23d99612] {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n}\n.d2-drawer-container .d2-drawer-container--body[data-v-23d99612] {\n  padding-left: 20px;\n  padding-right: 5px;\n}\n.d2-drawer-container .d2-drawer-container--body .d2-drawer-container--body-wrap[data-v-23d99612] {\n  padding-right: 15px;\n}\n.d2-drawer-container .d2-drawer-container--footer[data-v-23d99612] {\n  padding: 20px;\n}", ""]);
// Exports
module.exports = exports;
